export default __webpack_public_path__ + "static/media/IMG-20240729-WA0034.2d51f612.jpg";